import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function callGAFreeFittingEvent() {
    const category = GA_EVENTS.freeFitting.category;
    const action = GA_EVENTS.freeFitting.actions.click;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

export {
    callGAFreeFittingEvent
};
